import * as Yup from "yup";
import {
    dateCantBeInFuture,
    dateIsBefore
} from "./validationFunctions";

export const informationToReleaseValidations = (section, languageText) => {
    if (section.active) {
        return Yup.object().shape({
            dosFrom1: section.fields.dosfrom.validations.required.value && Yup.date()
                .required(
                    () => languageText.ErrorChecking.ValidatorText.MissingServiceStartDate
                ).nullable()
                .max(
                    dateCantBeInFuture,
                    languageText.ErrorChecking.ValidatorText.DateCantBeFuture
                )
                .test(
                    "dosfrom",
                    section.fields.dosfrom.validations.notFutureDate.message,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                ).test(
                    "afterBirthDate",
                    languageText.ErrorChecking.ValidatorText.StartDateAfterDob,
                    function () {
                        const { dosFrom1 } = this.parent;
                        const { PDOB1 } = this.parent;

                        if (dosFrom1 && PDOB1) {
                            return dateIsBefore(PDOB1, dosFrom1);
                        }
                    }
                ),

            dosTo1: section.fields.dosto.validations.required.value && Yup.date()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.MissingServiceEndDate
                ).nullable()
                .max(
                    dateCantBeInFuture,
                    languageText.ErrorChecking.ValidatorText.DateCantBeFuture
                )
                .test(
                    "afterFromDate",
                    languageText.ErrorChecking.ValidatorText.EndDateNotBeforeStart,
                    function (dosTo1) {
                        const { dosFrom1 } = this.parent;
                        if (dosFrom1 && dosTo1) {
                            return dateIsBefore(dosFrom1, dosTo1);
                        }
                    }
                )
                .test(
                    "afterFromDate",
                    section.fields.dosto.validations.notFutureDate.message,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                ),

            infoToReleaseGroup: section.fields.infoToReleaseGroup.validations.required.value && Yup.array().min(1,

                languageText.ErrorChecking.ValidatorText.MissingItemRelease
            ),

            infoToReleaseGroupOther: Yup.string()
                .test(
                    "infoToReleaseGroupOther",
                    section.fields.infoToReleaseGroupOther.validations.required.message,
                    function (item) {

                        const { infoToReleaseGroup } = this.parent;
                        if (infoToReleaseGroup.includes("otherItem"))
                            return item && infoToReleaseGroup.includes("otherItem");
                        else return true;
                    }
                )
                .max(
                    section.fields.infoToReleaseGroupOther.validations.maxLength
                        .value,
                    section.fields.infoToReleaseGroupOther.validations.maxLength
                        .message
                ),

            requestPurposePdf: section.fields.infoToReleaseGroup.validations.required.value && Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.MissingPurposeDisclosure
                ),
        });
    } else { return Yup.object().shape(); }
}
